"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Controllable;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _pick = _interopRequireDefault(require("../utils/underscore/pick"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _PropNames = require("../core/PropNames");

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _utils = require("./utils");

var _decorators = require("../utils/propTypes/decorators");

var DEFAULT_FIELDS = ['value'];
/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {Object}
 */

function _getDefaultProps(component, fields) {
  // shallow copy of defaultProps to use as the initial value to prevent mutation
  var defaultProps = (0, _extends2.default)({}, component.defaultProps);
  return fields.reduce(function (defaults, field) {
    if (defaults.hasOwnProperty(field)) {
      defaults[(0, _PropNames.getDefaultPropName)(field)] = defaults[field];
      delete defaults[field];
    }

    return defaults;
  }, defaultProps);
}
/**
 * @param  {Object}
 * @param  {Array<string>}
 * @return {Object}
 */


function getDefaultPropTypes(originalPropTypes, fields) {
  return fields.reduce(function (propTypes, field) {
    var originalPropType = propTypes[field];

    if (typeof originalPropType !== 'function') {
      originalPropType = _propTypes.default.any;
    }

    var notRequiredPropType = (0, _decorators.notRequired)(originalPropType);
    propTypes[(0, _PropNames.getDefaultPropName)(field)] = notRequiredPropType;
    propTypes[field] = notRequiredPropType;
    return propTypes;
  }, (0, _extends2.default)({}, originalPropTypes));
}
/**
 * @param  {Array<string>}
 * @return {Object}
 */


function getHandlerPropTypes(fields) {
  return fields.reduce(function (propTypes, field) {
    propTypes[(0, _PropNames.getOnChangeName)(field)] = _propTypes.default.func;
    return propTypes;
  }, {});
}
/**
 * @param  {ReactElement} instance
 * @param  {string} field
 * @param  {Object} event
 * @return {void}
 */


function handleChange(instance, field, evt) {
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant.default)(evt && evt.target != null, (0, _getComponentName.default)(instance.constructor) + " handleChange: expected " + 'argument in shape of SyntheticEvent ({target: value})');
  }

  instance.setState((0, _defineProperty2.default)({}, field, evt.target.value));
  var onChange = instance.props[(0, _PropNames.getOnChangeName)(field)];

  if (typeof onChange === 'function') {
    onChange(evt);
  }
}
/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {React.Component}
 */


function Controllable(InputComponent) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FIELDS;
  var onChangeKeys = fields.map(_PropNames.getOnChangeName);
  var defaultProps = fields.map(_PropNames.getDefaultPropName);
  var controlledComponent = (0, _createReactClass.default)({
    displayName: "Controllable(" + (0, _getComponentName.default)(InputComponent) + ")",
    propTypes: (0, _extends2.default)({}, getDefaultPropTypes(InputComponent.propTypes, fields), getHandlerPropTypes(fields)),

    /**
     * @return {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return _getDefaultProps(InputComponent, fields);
    },

    /**
     * @return {Object}
     */
    getInitialState: function getInitialState() {
      var defaults = (0, _pick.default)(this.props, defaultProps);
      var initialState = {};
      Object.keys(defaults).forEach(function (defaultKey) {
        initialState[(0, _PropNames.getPropFromDefaultName)(defaultKey)] = defaults[defaultKey];
      });
      return initialState;
    },

    /**
     * @return {void}
     */
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var _this = this;

      var handlers = {};
      onChangeKeys.forEach(function (onChangeKey, i) {
        handlers[onChangeKey] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return handleChange.apply(void 0, [_this, fields[i]].concat(args));
        };
      });
      this.handlers = handlers;
      this._refCallback = (0, _utils.makeDecoratorRefCallback)(InputComponent, this);
    },

    /**
     * @return {void}
     */
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      fields.forEach(function (field) {
        if (_this2.props[field] !== undefined && nextProps[field] === undefined) {
          _this2.setState((0, _defineProperty2.default)({}, field, nextProps[(0, _PropNames.getDefaultPropName)(field)]));
        }
      });
    },

    /**
     * @return {Object}
     */
    getProps: function getProps() {
      var _this3 = this;

      var applicableProps = {};
      Object.keys(this.props).forEach(function (key) {
        if (defaultProps.indexOf(key) === -1 && _this3.props[key] !== undefined) applicableProps[key] = _this3.props[key];
      });
      return (0, _extends2.default)({}, this.state, applicableProps, this.handlers);
    },

    /**
     * @return {React.Element}
     */
    render: function render() {
      return _react.default.createElement(InputComponent, (0, _extends2.default)({}, this.getProps(), {
        ref: this._refCallback
      }));
    }
  });
  (0, _utils.attachWrappedComponent)(controlledComponent, InputComponent);
  return controlledComponent;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/decorators/Controllable.js
// module id = 52
// module chunks = 5 6 7